
/**
 * This module is the mediator who control all the events in the app. 
 * This module is the bridge between all the modules. All modules communicate 
 * with each other using this module
 * @module mediator
 * @version 1
 * 
 */

import { i18n } from 'digicon-web-localization/localization';
import { LocalizationManager } from '../../js/managers/localizationManager';
import { Toastr } from 'digicon-web-feedback/utils/toastr/toastr';
import { InputForm } from 'project/modules/inputForm/inputForm';
import { LoginManager } from '../../js/managers/loginManager';
import { FileUploader } from '../inputForm/fileUploader';
import feedBack from 'digicon-web-feedback/feedBack';
import { Tables } from 'project/modules/tables/tables';
import { Operations } from 'project/modules/operations/operations';
import { Projects } from 'project/modules/projects/projects';

export class Mediator {

    constructor() {
        this.modules = {};
        this.managers = {};
        this.inputScreens = [];
        this.forms = [];
        this.structure = {};
        this.isFilledForm = {};
        this.toastr = new Toastr();
    }

    async init() {
        document.getElementById('splash').dataset.visible = true;
        new LocalizationManager(this.modules, this.managers);
        await this.managers.localizationManager.init();

        if (window.NodeList && !NodeList.prototype.filter) {
            NodeList.prototype.filter = Array.prototype.filter;
            NodeList.prototype.includes = Array.prototype.includes;
            NodeList.prototype.map = Array.prototype.map;
        }

        this._login();
        sessionStorage.setItem('backendUrl', `${location.href}webresources/`);
        this.modules.localization.subscribe('localize', () => {
            if (document.getElementById("login_root")) {
                location.reload();
            } else {
                document.querySelector('.close-session').innerHTML = i18n('closeSession');
                document.querySelector('.download-result').innerHTML = i18n('downloadResult');
                document.querySelector('.messages span').innerHTML = i18n('uncalculatedValues');
            }
        });
        document.getElementById('splash').dataset.visible = false;
    }

    _login() {
        new LoginManager(this.modules, this.managers);
        this.managers.loginManager.init(async () => await this._onLogIn());
    }

    async _onLogIn() {
        document.getElementById('splash').dataset.visible = true;
        document.querySelector('.user span').innerHTML = sessionStorage.lcoe_loginhash;
        document.querySelector('.user').style.display = 'block';
        document.querySelector('.close-session').innerHTML = i18n('closeSession');
        document.querySelector('.download-result').innerHTML = i18n('downloadResult');
        document.querySelector('.messages span').innerHTML = i18n('uncalculatedValues');
        document.querySelector('.selected-project .text').innerHTML = `${i18n('selectedProject')}: `;
        document.querySelector('.project-body .back .text').innerHTML = `${i18n('backToProjects')}`;
        document.querySelector('.close-session').addEventListener('click', (event) => {
            this.managers.loginManager.logOut();
        });
        document.querySelector('.download-result').addEventListener('click', async (event) => {
            await this._downloadResult();
        });
        document.querySelector('.project-body .back').addEventListener('click', async (event) => {
            sessionStorage.setItem('selected', null);
            await this.modules.projects._fillProjectsContainer();
            this.modules.projects._initProjectsStructure();
        });
        this.modules.localization.initButtonsUI();
        await this._onDataLoaded();
        if (sessionStorage.lcoe_uncalculated != null && sessionStorage.lcoe_uncalculated == "true") {
            document.querySelector('.messages').style.display = "block";
        } else {
            document.querySelector('.messages').style.display = "none";
        }
        document.getElementById('splash').dataset.visible = false;
    }

    async _onDataLoaded() {
        this.modules.tables = new Tables({ modules: this.modules });
        this.modules.operations = new Operations({ modules: this.modules });
        this.modules.projects = new Projects({ modules: this.modules });
        sessionStorage.setItem('uncalculated', false);
        await this.modules.projects._fillProjectsContainer();
        this.modules.projects._initProjectsStructure();
        this.modules.projects.subscribe('onUserSelectProject', async (project) => {
            document.getElementById('splash').dataset.visible = true;
            sessionStorage.setItem('selected', project);
            if (document.querySelector('.createProject') != null) {
                document.querySelector('.createProject').remove();
            }
            let rawResponse = await fetch(`${location.href}webresources/lcoeF3/getProject?` + new URLSearchParams({
                username: sessionStorage.lcoe_loginhash,
                projectId: sessionStorage.lcoe_selected
            }), {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            const result = await rawResponse.json();
            if (result.status === 200) {
                document.querySelector('.selected-project .selected').innerHTML = result.data.name;
            }
            document.querySelector('.container-xxl > div.title').style.justifyContent = "space-between";
            document.querySelector('.container-xxl .card-body').classList.remove('card-body-projects');
            document.querySelector('.content').style.padding = "0px 0px";
            document.querySelector('.project-body').style.display = "block";
            await this._isFilled();
            await this._initStructure();
            await this._initMenu();
            if (Object.values(this.isFilledForm).every((v) => v === true)) {
                document.querySelector('#steps').style.display = "none";
                document.querySelector('#content').style.marginTop = "0px";
                const titleList = document.querySelectorAll(".menu-link .menu-title");
                titleList[5].classList.add('selected');
                document.querySelector('.aside').style.display = "block";
                document.querySelector('.container-xxl').classList.add("with-aside");
                const result = this.structure.categories[0].tabs.find(x => x.id === parseInt(titleList[5].getAttribute('data-tab')));
                await this._fillOutputContainer(result, parseInt(titleList[5].getAttribute('data-tab')));
            }
            else {
                document.querySelector('.aside').style.display = "none";
                document.querySelector('.container-xxl').classList.remove("with-aside");
                document.querySelector('.wrapper').classList.add('px-0');
                document.querySelector('#steps').style.display = "block";
                document.querySelector('#content').style.marginTop = "95px";
            }
            document.getElementById('splash').dataset.visible = false;
        });
        document.querySelector('.messages').style.display = "none";
    }

    async _downloadResult() {
        await fetch(`${location.href}webresources/lcoeF3/downloadResults?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected
        }), {
            method: 'get'
        }).then(response => response.blob())
            .then(blob => {
                const date = new Date();
                const dateStr =
                    date.getFullYear() + "_" +
                    ("00" + date.getDate()).slice(-2) + "_" +
                    ("00" + (date.getMonth() + 1)).slice(-2) + "_" +
                    ("00" + date.getHours()).slice(-2) + "_" +
                    ("00" + date.getMinutes()).slice(-2) + "_" +
                    ("00" + date.getSeconds()).slice(-2);
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `LCOE Assessment_Unica_${dateStr}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
    }

    async _isFilled() {
        let rawResponse = await fetch(`${location.href}webresources/lcoeF3/getFilledForms?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const result = await rawResponse.json();
        if (result.status === 200) {
            this.isFilledForm = result.data;
        }
    }

    async _initStructure() {
        let rawResponse = await fetch(`${location.href}webresources/lcoeF3/getStructure?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const result = await rawResponse.json();
        if (document.querySelector('.menu').innerHTML != '') {
            document.querySelector('.menu').innerHTML = '';
        }
        if (result.status === 200) {
            this.structure = result.data;
            let inputMenu = '';
            this.structure.forms.forEach(function callback(element) {
                inputMenu = inputMenu + `<div class="menu-sub menu-sub-accordion show">
                    <div class="menu-item">
                        <div class="menu-link pointer"><span class="menu-title" data-form="${element.id}">${element['name_' + this.modules.localization.getLocale().split('-')[0]]}</span></div>
                    </div>
                </div>`;
            }, this);
            document.querySelector('.menu').insertAdjacentHTML(
                'beforeend',
                `<div class="menu-item">
                    <span class="no-color">
                        <span class="menu-title">${i18n('inputs')}</span>
                            ${inputMenu}
                        </div>
                    </span>
                </div>`
            );
            let outputMenu = '';
            this.structure.categories[0].tabs.forEach(function callback(element) {
                outputMenu = outputMenu + `<div class="menu-sub menu-sub-accordion show">
                    <div class="menu-item">
                        <div class="menu-link pointer">
                            <span class="menu-title" data-tab="${element.id}">
                                ${element['tab_' + this.modules.localization.getLocale().split('-')[0]]}
                            </span>
                        </div>
                    </div>
                </div>`;
            }, this);
            document.querySelector('.menu').insertAdjacentHTML(
                'beforeend',
                `<div class="menu-item">
                    <span class="no-color">
                        <span class="menu-title">${i18n('outputs')}</span>
                            ${outputMenu}
                        </div>
                    </span>
                </div>`
            );
            const operationsMenu = `<div class="menu-sub menu-sub-accordion show">
                <div class="menu-item">
                    <div class="menu-link pointer"><span class="menu-title" data-form="100">${i18n('varianceAnalysis')}</span></div>
                    <div class="menu-link pointer"><span class="menu-title" data-form="101">${i18n('sensitivityAnalysis')}</span></div>
                </div>
            </div>`
            document.querySelector('.menu').insertAdjacentHTML(
                'beforeend',
                `<div class="menu-item">
                    <span class="no-color">
                        <span class="menu-title">${i18n('operations')}</span>
                            ${operationsMenu}
                        </div>
                    </span>
                </div>`
            );
        }
    }

    async _initMenu() {
        const rawResponse = await fetch(`${location.href}webresources/lcoeF3/getInputForms?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const result = await rawResponse.json();
        if (result.status === 200) {
            this.inputScreens = result.data;
            for (let i = 0; i < this.inputScreens[4].screens[0].forms.length; i++) { }
            this.inputScreens[4].screens[0].forms.forEach((element, index) => {
                if (index != 0 && element.form_data.length > 0 && element.category_en != "Dismantling" && element.category_en != "Dismantling and recycling costs") {
                    let newArr = [];
                    for (let i = 0; i < element.form_data.length; i++) {
                        newArr.push(element.form_data[i]);
                        if (element.form_data[i].data_type != 'IMAGE') {
                            let newOpt = {
                                data_type: "CHK",
                                id: `${element.form_data[i].id}_OPT`,
                                value: element.form_data[i].prop,
                                name_en: "Copy value to the following years"
                            }
                            newArr.push(newOpt);
                        }
                    }
                    element.form_data = newArr;
                }
            });
            this.inputScreens.slice().reverse().forEach(function callback(element) {
                document.querySelector('#progressbar').insertAdjacentHTML(
                    'afterbegin',
                    `<li data-menu="${element.id}">${element['name_' + this.modules.localization.getLocale().split('-')[0]]}</li>`
                );
                document.querySelector(`#progressbar li[data-menu="${element.id}"]`).addEventListener('click', (event) => {
                    const dataMenu = event.currentTarget.getAttribute('data-menu');
                    if (this.isFilledForm[dataMenu] || (this.isFilledForm[dataMenu - 1])) {
                        this._fill(parseInt(dataMenu) + 1);
                    }
                });
            }, this);
            if (Object.values(this.isFilledForm).every((v) => v === true)) {
                const link = document.querySelectorAll(".menu-link");
                for (let i = 0; i < link.length; i++) {
                    link[i].addEventListener("click", async (event) => {
                        const selected = document.querySelectorAll(".menu-title.selected");
                        for (let j = 0; j < selected.length; j++) {
                            selected[j].classList.remove('selected');
                        }
                        event.currentTarget.querySelector('.menu-title').classList.add('selected');
                        if (event.currentTarget.querySelector('.menu-title').hasAttribute('data-tab')) {
                            await this._menuClick('tab', parseInt(event.currentTarget.querySelector('.menu-title').getAttribute('data-tab')));
                        }
                        else {
                            await this._menuClick('form', parseInt(event.currentTarget.querySelector('.menu-title').getAttribute('data-form')));
                        }
                    });
                }
            } else {
                const lastActive = this._refreshProgressBar();
                await this._fill(lastActive);
            }
        }
    }

    async _menuClick(type, id) {
        document.getElementById('splash').dataset.visible = true;
        //Operations
        if (id == 100 || id == 101) {
            if (id == 100) {
                await this.modules.operations._fillLCOEVarianceAnalysisContainer(this.structure.forms, this.inputScreens);
            } else {
                await this.modules.operations._fillSensitivityAnalysisContainer(this.structure.forms, this.inputScreens);
            }
        } else {
            if (type == 'tab') {
                if (id === 200) {
                    await this._fillProjectsContainer();
                } else {
                    const result = this.structure.categories[0].tabs.find(x => x.id === id);
                    await this._fillOutputContainer(result, id);
                }
            } else {
                //const result = this.structure.forms.find(x => x.id === id);
                const res = this.inputScreens[id].screens[0];
                await this._fillContainer(res, id, false);
            }
        }
        document.getElementById('splash').dataset.visible = false;
    }

    async _fill(lastActive) {
        const menuElem = document.querySelector(`#progressbar li:nth-child(${lastActive})`).getAttribute('data-menu');
        const res = this.inputScreens[menuElem].screens[0];
        await this._fillContainer(res, menuElem, true);
    }

    async _fillOutputContainer(data, id) {
        document.querySelector('.container-xxl h2').innerText = data['tab_' + this.modules.localization.getLocale().split('-')[0]];
        const rawResponse = await fetch(`${location.href}webresources/lcoeF3/getResults?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash,
            projectid: sessionStorage.lcoe_selected,
            tabid: id
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const result = await rawResponse.json();
        if (result.status === 200) {
            document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="outputFormContainer" class="outputFormContainer" data-id="${id}"></div>`;
            const data = result.data;
            if (data.tables.length > 0) {
                this.modules.tables.createTables(data.tables);
            }
        }
    }

    async _fillContainer(data, id, isProgressBar, year = null) {
        const elements = document.getElementsByClassName("buttons");
        while (elements.length > 0) elements[0].remove();
        let inputResult = await this.getInput(id);
        document.querySelector('.container-xxl h2').innerText = data['name_' + this.modules.localization.getLocale().split('-')[0]];
        if (parseInt(id) == 1) {
            document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="inputFormContainer" class="inputFormContainer" data-id="${id}"></div>`;
        } else if (parseInt(id) == 4 && !isProgressBar) {
            document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="inputFormContainer" class="inputFormContainer" data-id="${id}"></div><div class="buttons"><button type="button" class="btn primary save">${i18n('save')}</button><button type="button" class="btn primary ms-3 save_calculate">${i18n('saveAndCalculate')}</button></div>`;
        } else if (isProgressBar) {
            document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="inputFormContainer" class="inputFormContainer" data-id="${id}"></div><div class="buttons"><button type="button" class="btn primary save_calculate">${i18n('save')}</button></div>`;
        } else {
            document.querySelector('.container-xxl .card-body #content').innerHTML = `<div id="inputFormContainer" class="inputFormContainer" data-id="${id}"></div><div class="buttons"><button type="button" class="btn primary save">${i18n('save')}</button><button type="button" class="btn primary ms-3 save_calculate">${i18n('saveAndCalculate')}</button></div>`;
        }

        this.modules[`inputForm`] = new InputForm({ container: `inputFormContainer`, modules: this.modules, locale: this.modules.localization.getLocale(), data: inputResult });

        this.modules[`inputForm`].setFormsData(data);
        if (Object.keys(inputResult).length > 0) {
            this.modules[`inputForm`].updateData();
        }
        this.modules[`inputForm`].clear();
        this.modules[`inputForm`].update();

        if (!isProgressBar) {
            document.querySelector('#inputFormContainer').classList.add('full');
        }
        if (parseInt(id) == 4 && isProgressBar) {
            document.querySelector('#inputFormContainer').insertAdjacentHTML(
                'afterbegin',
                `<div>
                    <div class="caja10px">
                        <label for="formControlYear" class="formLabel">${i18n('year')}</label>
                        <select class="forms-input" id="formControlYear" disabled>
                            <option>1</option>
                        </select>
                    </div>
                </div>`
            );
        } else if (parseInt(id) == 4 && !isProgressBar) {
            const years = inputResult.data.find(x => x.key === 'OP01').value;
            let options = '';
            for (let i = 1; i <= parseInt(years); i++) {
                if (year != null && i == year) {
                    options = options + `<option value="${i}" selected>${i}</option>`;
                } else {
                    options = options + `<option value="${i}">${i}</option>`;
                }
            }
            document.querySelector('#inputFormContainer').insertAdjacentHTML(
                'afterbegin',
                `<div>
                    <div class="caja10px">
                        <label for="formControlYear" class="formLabel">${i18n('year')}</label>
                        <div class="input-group year-selector mb-3">
                            <select class="form-select" id="formControlYear">
                                ${options}
                            </select>
                        </div>
                    </div>
                </div>`
            );
            document.querySelector("#formControlYear").addEventListener('change', async (event) => {
                const e = document.getElementById("formControlYear");
                let value = 1;
                if (e != null) {
                    value = e.options[e.selectedIndex].value;
                }
                await this._fillContainer(data, 4, false, value);
            }, this);
        }
        document.querySelector('.caja10px .errorLog').parentElement.remove();
        if (document.querySelector(`.buttons .save`) != null) {
            document.querySelector(`.buttons .save`).addEventListener('click', async (event) => {
                await this._save();
            }, this);
        }
        if (document.querySelector(`.buttons .save_calculate`) != null) {
            document.querySelector(`.buttons .save_calculate`).addEventListener('click', async (event) => {
                await this._saveAndCalulate();
            }, this);
        }
        if (document.querySelector('#WE05') != null) {
            document.querySelector('#content').insertAdjacentHTML(
                'afterbegin',
                `<div class="caja10px">
                    <label for="formControlFutureWeather" class="formLabel">${i18n('mode')}</label>
                    <select class="forms-input" id="formControlFutureWeather">
                        <option value="0">${i18n('withoutClimateChange')}</option>
                        <option value="1">${i18n('withClimateChange')}</option>
                    </select>
                </div>`
            );
            const filename = typeof (inputResult.data) === 'undefined' || typeof (inputResult.data[0].filename) === 'undefined' ? 'No file uploaded' : inputResult.data[0].filename;
            let filename2 = 'No file uploaded';
            let filename3 = 'No file uploaded';
            let filename4 = 'No file uploaded';
            if (typeof (inputResult.data) !== 'undefined' && inputResult.data.length > 1) {
                filename2 = inputResult.data[1].filename;
                filename3 = inputResult.data[2].filename;
                filename4 = inputResult.data[3].filename;
                document.querySelector('#formControlFutureWeather').value = 1;
            }
            document.querySelector('#form_Radiationdata_WE01').insertAdjacentHTML(
                'beforebegin',
                `<div class="caja10px filename">
                    <span>Uploaded file: <b>${filename}</b></span>
                </div>`
            );
            document.querySelector('[id$=WE02]').insertAdjacentHTML(
                'beforebegin',
                `<div class="caja10px filename">
                    <span>Uploaded file: <b>${filename2}</b></span>
                </div>`
            );
            document.querySelector('[id$=WE03]').insertAdjacentHTML(
                'beforebegin',
                `<div class="caja10px filename">
                    <span>Uploaded file: <b>${filename3}</b></span>
                </div>`
            );
            document.querySelector('[id$=WE04]').insertAdjacentHTML(
                'beforebegin',
                `<div class="caja10px filename">
                    <span>Uploaded file: <b>${filename4}</b></span>
                </div>`
            );
            if (document.getElementById("formControlFutureWeather").value == "0") {
                document.querySelector('[id$=WE02]').style.display = 'none';
                document.querySelector('[id$=WE02]').previousSibling.style.display = 'none';
                document.querySelector('[id$=WE02]').previousSibling.previousSibling.style.display = 'none';
                document.querySelector('[id$=WE03]').style.display = 'none';
                document.querySelector('[id$=WE03]').previousSibling.style.display = 'none';
                document.querySelector('[id$=WE03]').previousSibling.previousSibling.style.display = 'none';
                document.querySelector('[id$=WE04]').style.display = 'none';
                document.querySelector('[id$=WE04]').previousSibling.style.display = 'none';
                document.querySelector('[id$=WE04]').previousSibling.previousSibling.style.display = 'none';
            }
            document.querySelector('#formControlFutureWeather').addEventListener('change', async (event) => {
                if (event.currentTarget.value == "0") {
                    document.querySelector('[id$=WE02]').style.display = 'none';
                    document.querySelector('[id$=WE02]').previousSibling.style.display = 'none';
                    document.querySelector('[id$=WE02]').previousSibling.previousSibling.style.display = 'none';
                    document.querySelector('[id$=WE03]').style.display = 'none';
                    document.querySelector('[id$=WE03]').previousSibling.style.display = 'none';
                    document.querySelector('[id$=WE03]').previousSibling.previousSibling.style.display = 'none';
                    document.querySelector('[id$=WE04]').style.display = 'none';
                    document.querySelector('[id$=WE04]').previousSibling.style.display = 'none';
                    document.querySelector('[id$=WE04]').previousSibling.previousSibling.style.display = 'none';
                } else {
                    document.querySelector('[id$=WE02]').style.display = 'block';
                    document.querySelector('[id$=WE02]').previousSibling.style.display = 'block';
                    document.querySelector('[id$=WE02]').previousSibling.previousSibling.style.display = 'block';
                    document.querySelector('[id$=WE03]').style.display = 'block';
                    document.querySelector('[id$=WE03]').previousSibling.style.display = 'block';
                    document.querySelector('[id$=WE03]').previousSibling.previousSibling.style.display = 'block';
                    document.querySelector('[id$=WE04]').style.display = 'block';
                    document.querySelector('[id$=WE04]').previousSibling.style.display = 'block';
                    document.querySelector('[id$=WE04]').previousSibling.previousSibling.style.display = 'block';
                }
            });
            document.querySelector('#WE05').addEventListener('click', async (event) => {
                if (document.getElementById("formControlFutureWeather").value == 0) {
                    const formData = this.modules['inputForm'].getFormData();
                    const csvFile1 = formData["WE01"];
                    if (typeof (csvFile1) !== 'undefined') {
                        this._uploadWeatherFile();
                    }
                    else {
                        this.toastr.error(i18n("notSelectedFiles"), i18n("someFilesNotSelected"));
                    }
                } else {
                    const formData = this.modules['inputForm'].getFormData();
                    const csvFile1 = formData["WE01"];
                    const csvFile2 = formData["WE02"];
                    const csvFile3 = formData["WE03"];
                    const csvFile4 = formData["WE04"];
                    if (typeof (csvFile1) !== 'undefined' && typeof (csvFile2) !== 'undefined' && typeof (csvFile3) !== 'undefined' && typeof (csvFile4) !== 'undefined') {
                        this._uploadWeatherFile();
                    }
                    else {
                        this.toastr.error(i18n("notSelectedFiles"), i18n("someFilesNotSelected"));
                    }
                }
            }, this);
        }
    }

    _uploadWeatherFile() {
        let formData = this.modules['inputForm'].getFormData();
        const csvFile = [];
        if (typeof (formData["WE01"]) !== 'undefined') {
            csvFile.push(formData["WE01"]);
        }
        if (typeof (formData["WE02"]) !== 'undefined') {
            csvFile.push(formData["WE02"]);
        }
        if (typeof (formData["WE01"]) !== 'undefined') {
            csvFile.push(formData["WE03"]);
        }
        if (typeof (formData["WE01"]) !== 'undefined') {
            csvFile.push(formData["WE04"]);
        }

        if (csvFile.length > 0) {
            let loader = new FileUploader();
            loader.subscribe('onUploadProgress', (e) => {
                feedBack.showLoading(i18n('UploadingFile', [e]));
            });
            loader.subscribe('onUploadCompleted', async (e) => {
                feedBack.closeFeedBack();
                document.getElementById('splash').dataset.visible = true;
                await this._isFilled();
                if (Object.values(this.isFilledForm).every((v) => v === true)) {
                    await this._fill(2);
                } else {
                    const lastActive = this._refreshProgressBar();
                    await this._fill(lastActive);
                }

                document.getElementById('splash').dataset.visible = false;
            });
            loader.subscribe('onUploadFailed', () => {
                feedBack.closeFeedBack();
            });
            loader.subscribe('onNoFileSelected', () => {
                feedBack.closeFeedBack();
            });
            loader.upload('GENERATED', [csvFile], 'cee');
        }
    }

    async _save() {
        let result = [];
        const total = Object.keys(this.modules).filter((module) => module.startsWith("inputForm")).length;
        for (let i = 0; i < total; i++) {
            const res = this.modules['inputForm'].formsData.form.checkFormError(true);
            if (res != null) {
                result.push(res);
            }
        }
        if (result.length == 0) {
            const id = document.querySelector('#inputFormContainer').getAttribute('data-id');
            const formData = this.modules['inputForm'].getFormData();
            this.setInput(id, formData, "save").then(function () {
                //feedBack.closeFeedBack();
            });
        }
    }

    async _saveAndCalulate() {
        let result = [];
        const total = Object.keys(this.modules).filter((module) => module.startsWith("inputForm")).length;
        for (let i = 0; i < total; i++) {
            const res = this.modules['inputForm'].formsData.form.checkFormError(true);
            if (res != null) {
                result.push(res);
            }
        }
        if (result.length == 0) {
            const id = document.querySelector('#inputFormContainer').getAttribute('data-id');
            const formData = this.modules['inputForm'].getFormData();
            this.setInput(id, formData, "calculate").then(function () {
                //feedBack.closeFeedBack();
            });
        }
    }

    _refreshProgressBar() {
        document.querySelectorAll(`#progressbar li`).forEach((element) => {
            element.classList.remove('active');
        });
        let lastActive = 0;
        for (let k = 0; k < Object.keys(this.isFilledForm).length; k++) {
            lastActive = k + 1;
            if (this.isFilledForm[k]) {
                document.querySelector(`#progressbar li:nth-child(${k + 1})`).classList.add('active');
            } else {
                document.querySelector(`#progressbar li:nth-child(${k + 1})`).classList.add('active');
                break;
            }
        };
        return lastActive;
    }

    async getInput(id) {
        let rawResponse = null;
        if (id == 4) {
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/getInput?` + new URLSearchParams({
                username: sessionStorage.lcoe_loginhash,
                projectid: sessionStorage.lcoe_selected,
                form_id: id,
                input_id: 0
            }), {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            let result = await rawResponse.json();
            if (result.status !== 200) {
                return {};
            }
            const e = document.getElementById("formControlYear");
            let value = 1;
            if (e != null) {
                value = e.options[e.selectedIndex].value;
            }
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/getInOpexYearInput?` + new URLSearchParams({
                username: sessionStorage.lcoe_loginhash,
                projectid: sessionStorage.lcoe_selected,
                year: value
            }), {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            const result2 = await rawResponse.json();
            if (result2.status === 200) {
                for (let i = 0; i < result2.data.length; i++) {
                    let index = Object.keys(result2.data[i]).findIndex(element => element.includes("OP"));
                    result.data.data.push({
                        'key': Object.keys(result2.data[i])[index],
                        'value': Object.values(result2.data[i])[index],
                        'prop': result2.data[i].prop
                    });
                }
                return result.data;
            } else {
                return result.data;
            }
        } else {
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/getInput?` + new URLSearchParams({
                username: sessionStorage.lcoe_loginhash,
                projectid: sessionStorage.lcoe_selected,
                form_id: id,
                input_id: 0
            }), {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            const result = await rawResponse.json();
            if (result.status === 200) {
                return result.data;
            } else {
                return {};
            }
        }
    }

    async setInput(id, formData, operation) {
        document.getElementById('splash').dataset.visible = true;
        let rawResponse = null;
        if (id == 4) {
            let data = [];
            const keys = Object.keys(formData);
            for (let key in formData) {
                const splitted = key.split('_');
                if (formData[key] != '' && !key.includes('_OPT') && !formData[key].includes('data:image/png;') && !keys.includes(`${key}_OPT`) && (typeof (splitted[1]) == 'undefined' || (typeof (splitted[1]) == 'string' && formData[splitted[0]] == splitted[1]))) {
                    data.push({
                        "key": key,
                        "value": formData[key]
                    });
                }
            }
            let bodyData = `{
                "username": "${sessionStorage.lcoe_loginhash}",
                "project_id": "${sessionStorage.lcoe_selected}",
                "form_id": ${id},
                "input": {
                    "id": 0,
                    "data": ${JSON.stringify(data)}
                }
            }`;
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/setInput`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: bodyData
            });
            data = [];
            for (let key in formData) {
                const splitted = key.split('_');
                if (formData[key] != '' && !key.includes('_OPT') && !formData[key].includes('data:image/png;') && keys.includes(`${key}_OPT`) && (typeof (splitted[1]) == 'undefined' || (typeof (splitted[1]) == 'string' && formData[splitted[0]] == splitted[1]))) {
                    let d = { prop: formData[`${key}_OPT`] };
                    d[key] = formData[key];
                    data.push(d);
                }
            }
            const e = document.getElementById("formControlYear");
            const value = e.options[e.selectedIndex].value;
            bodyData = `{
                "username": "${sessionStorage.lcoe_loginhash}",
                "project_id": "${sessionStorage.lcoe_selected}",
                "input": {
                    "${value}": ${JSON.stringify(data)}
                }
            }`;
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/setInOpexYearsInput`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: bodyData
            });
            //Eliminar años i ha habido cambio de fecha
            var theSelect = document.getElementById('formControlYear');
            var lastValue = theSelect.options[theSelect.options.length - 1].value;
            const years = Object.values(formData)[Object.keys(formData).findIndex(x => x == "OP01")];
            if (parseInt(years) < parseInt(lastValue)) {
                for (let i = parseInt(years) + 1; i <= parseInt(lastValue); i++) {
                    bodyData = `{
                        "username": "${sessionStorage.lcoe_loginhash}",
                        "project_id": "${sessionStorage.lcoe_selected}",
                        "year": "${i}"
                    }`;
                    rawResponse = await fetch(`${location.href}webresources/lcoeF3/deleteInOpexYearInput`, {
                        method: 'delete',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: bodyData
                    });
                }
            }
        } else {
            let data = [];
            for (let key in formData) {
                const splitted = key.split('_');
                if (formData[key] != '' && (typeof (splitted[1]) == 'undefined' || (typeof (splitted[1]) == 'string' && formData[splitted[0]] == splitted[1]))) {
                    data.push({
                        "key": key,
                        "value": formData[key]
                    });
                }
            }
            const bodyData = `{
                "username": "${sessionStorage.lcoe_loginhash}",
                "project_id": "${sessionStorage.lcoe_selected}",
                "form_id": ${id},
                "input": {
                    "id": 0,
                    "data": ${JSON.stringify(data)}
                }
            }`;
            rawResponse = await fetch(`${location.href}webresources/lcoeF3/setInput`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: bodyData
            });
        }
        const result = await rawResponse.json();
        if (result.status === 200) {
            await this._isFilled();
            document.getElementById('splash').dataset.visible = false;
            this.toastr.success(i18n("saved"), "");
            if (operation == "save") {
                sessionStorage.setItem('uncalculated', true);
                document.querySelector('.messages').style.display = "block";
            }
            else if (operation == "calculate") {
                if (Object.values(this.isFilledForm).every((v) => v === true)) {
                    if (document.querySelector('#steps').style.display == 'none') {
                        //refresh
                        document.getElementById('splash').dataset.visible = true;
                        var data = `{
                            "username": "${sessionStorage.lcoe_loginhash}",
                            "project_id": "${sessionStorage.lcoe_selected}"
                        }`;
                        let rawResponse = await fetch(`${location.href}webresources/lcoeF3/calculate`, {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: data
                        });
                        const result = await rawResponse.json();
                        if (result.status === 200) {
                            document.getElementById('splash').dataset.visible = false;
                            this.toastr.success(i18n("New calculations have been made"), "");
                            const id = parseInt(document.querySelector(".menu-title.selected").getAttribute('data-form'));
                            const res = this.inputScreens[id].screens[0];
                            const e = document.getElementById("formControlYear");
                            let value = 1;
                            if (e != null) {
                                value = e.options[e.selectedIndex].value;
                            }
                            await this._fillContainer(res, id, false, value);
                        } else {
                            document.getElementById('splash').dataset.visible = false;
                            this.toastr.error(i18n("failedToUpdate"), "");
                        }
                    } else {
                        document.getElementById('splash').dataset.visible = true;
                        var data = `{
                            "username": "${sessionStorage.lcoe_loginhash}",
                            "project_id": "${sessionStorage.lcoe_selected}"
                        }`;
                        let rawResponse = await fetch(`${location.href}webresources/lcoeF3/calculate`, {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: data
                        });
                        const result = await rawResponse.json();
                        if (result.status === 200) {
                            document.querySelector('#steps').style.display = "none";
                            document.querySelector('#content').style.marginTop = "0px";
                            document.querySelector('.aside').style.display = "block";
                            document.querySelector('.container-xxl').classList.add("with-aside");
                            document.querySelector('.wrapper').classList.remove('px-0');
                            const titleList = document.querySelectorAll(".menu-link .menu-title");
                            titleList[5].classList.add('selected');
                            this._initMenu();
                            const result2 = this.structure.categories[0].tabs.find(x => x.id === parseInt(titleList[5].getAttribute('data-tab')));
                            await this._fillOutputContainer(result2, parseInt(titleList[5].getAttribute('data-tab')));
                            document.getElementById('splash').dataset.visible = false;
                            this.toastr.success(i18n("New calculations have been made"), "");
                            sessionStorage.setItem('uncalculated', false);
                            document.querySelector('.messages').style.display = "none";
                        } else {
                            document.getElementById('splash').dataset.visible = false;
                            this.toastr.error(i18n("failedToUpdate"), "");
                        }
                    }
                }
                else {
                    const lastActive = this._refreshProgressBar();
                    await this._fill(lastActive);
                }
            }

        } else {
            document.getElementById('splash').dataset.visible = false;
            this.toastr.error(i18n("failedToCreate"), "");
        }
    }
}